import styled, { keyframes } from 'styled-components';
import { viewports } from 'app/shared/styles/_breakpoints';
import { colors } from 'app/shared/styles/_colors';
import Text from 'app/shared/core/Text';
import { font } from 'app/shared/styles/_fontsize';

export const Container = styled.div`
  box-shadow: 0 2px 6px ${colors['$hpx-grey-400']};
  padding: 15px;
  margin: 0 auto;
  width: 100%;
  border-radius: 10px;
`;

export const HeaderText = styled.h2`
  font-weight: bold;
  ${font.lg}
`;

export const NearbyAreas = styled.ul`
  gap: 10px;
  padding-top: 10px;
  display: grid;
  grid-template-columns: 1fr 1fr;

  @media ${viewports['md-and-up']} {
    grid-template-columns: 1fr 1fr 1fr;
  }
`;

interface NearbyAreaButtonProps {
  hasLongNameMobile?: boolean;
}

export const NearbyAreaButton = styled.a`
  display: flex;
  gap: 5px;
  align-items: center;
  justify-content: center;
  border-radius: 4px;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
  padding: 7px;

  @media ${viewports['sm-and-below']} {
    grid-column: ${(props: NearbyAreaButtonProps) => (props?.hasLongNameMobile ? 'span 2' : 'auto')};
  }

  @media ${viewports['md-and-up']} {
    gap: 10px;
    padding: 7px 15px;
  }

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
      background-color: ${colors['$hpx-grey-100']};
      transition: background-color 0.3s ease-in-out;
      text-decoration: none;
    }
  }

  &:focus {
    background-color: ${colors['$hpx-grey-100']};
    transition: background-color 0.3s ease-in-out;
  }
`;

export const SearchIcon = styled.img`
  width: 15px;
  height: 15px;
`;

export const NearbyAreaName = styled(Text)`
  font-weight: bold;
  color: ${colors['$hpx-black']};
`;

const breatheAnimation = keyframes`
    0% {
        opacity: 1;
    }
    50% {
        opacity: 0.6;
    }
    100% {
        opacity: 1;
    }
`;

export const HeaderTextSkeleton = styled.div`
  background-color: ${colors['$hpx-grey-400']};
  height: 20px;
  width: 80%;
  animation: ${breatheAnimation} 1.5s infinite;

  @media ${viewports['md-and-up']} {
    width: 40%;
  }
`;

export const ButtonSkeleton = styled.div`
  background-color: ${colors['$hpx-grey-400']};
  border-radius: 4px;
  height: 33.19px;
  animation: ${breatheAnimation} 1.5s infinite;
`;
